import styled from '../../utils/styled';
import { mediaBreakpointDownMD, mediaBreakpointUpXL } from '../../../constants/style-constants';

const getBackgroundColor = open => (open ? '#101010' : '#0f0f0f');

export const ButtonContainer = styled.button(({ open }) => ({
  alignItems: 'baseline',
  backgroundColor: getBackgroundColor(open),
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  display: 'flex',
  fontFamily: '"Spyscapetwo webfont", sans-serif',
  fontSize: '12px',
  fontWeight: '300',
  height: '40px',
  justifyContent: 'center',
  lineHeight: '2.17',
  outline: 'none',
  padding: '7px',
  transition: 'background-color 0.3s linear',
  textTransform: 'uppercase',

  '&:hover': {
    backgroundColor: '#383838',
    color: '#fff',
  },

  '> img': {
    transition: 'transform 0.3s linear',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  },

  [mediaBreakpointUpXL]: {
    margin: '20px 15px',
  },
}));

export const ButtonText = styled.div({
  display: 'block',
  paddingRight: '10px',
  fontFamily: "'Spyscapetwo webfont',sans-serif",
});

export const ButtonIcon = styled.img({
  display: 'block',
  [mediaBreakpointDownMD]: {
    paddingLeft: '0px',
  },
});
